import { CustomText, Label } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { Col, InputNumber, Row } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useUserPolicy } from '../../../user-policy';
import BwgButton from '../../atoms/Button';
import TagsEmail from '../../molecules/TagsEmail';

function BenefitOrderParametrizationForm({ onSubmitClick, parametrization }) {
  const [draft, setDraft] = useState(parametrization);
  const isInvalidDateRange = draft && draft.startDay > draft.endDay;
  const { userAccount } = useUserPolicy();
  const isEditingDisabled = userAccount.ability.cannot('update', 'benefit-order.parameterization');

  useEffect(() => {
    setDraft(parametrization);
  }, [parametrization]);

  return (
    <>
      <Row
        gutter={16}
        style={{ marginTop: 16 }}
      >
        <Col flex="130px">
          <Label label="Dia de abertura">
            <InputNumber
              value={draft.startDay}
              min={1}
              max={31}
              style={{ width: '120px' }}
              placeholder="1 - 31"
              disabled={isEditingDisabled}
              onChange={(value) => {
                setDraft({ ...draft, startDay: value });
              }}
            />
          </Label>
        </Col>
        <Col flex="130px">
          <Label label="Dia de fechamento">
            <InputNumber
              value={draft.endDay}
              min={1}
              max={31}
              style={{ width: '120px' }}
              placeholder="1 - 31"
              disabled={isEditingDisabled}
              onChange={(value) => {
                setDraft({ ...draft, endDay: value });
              }}
            />
          </Label>
        </Col>
      </Row>
      <Row>
        {isInvalidDateRange && (
          <Col flex="1">
            <CustomText color="var(--error)">O dia de abertura não pode ser posterior ao dia de fechamento.</CustomText>
          </Col>
        )}
      </Row>

      <Row
        gutter={16}
        style={{ marginTop: 16 }}
      >
        <Col>
          <Label label={<div style={{ display: 'flex' }}>Emails para alerta</div>}>
            <TagsEmail
              emails={draft.notificationEmails}
              disabled={isEditingDisabled}
              onChange={(em) => {
                if (em) {
                  setDraft({ ...draft, notificationEmails: em });
                }
              }}
            />
          </Label>
        </Col>
      </Row>
      {!isEditingDisabled && (
        <Row style={{ marginTop: '40px' }}>
          <Col>
            <BwgButton
              onClick={() => onSubmitClick(draft)}
              type="primary"
              style={{ width: '120px' }}
              disabled={isInvalidDateRange}
            >
              Salvar
            </BwgButton>
          </Col>
        </Row>
      )}
    </>
  );
}

BenefitOrderParametrizationForm.propTypes = {
  onSubmitClick: PropTypes.func.isRequired,
  parametrization: PropTypes.shape(),
};

BenefitOrderParametrizationForm.defaultProps = {
  parametrization: {},
};

export default BenefitOrderParametrizationForm;
